import TransactionActionTypes from './transaction.types'

const INITIAL_STATE = {
  data: null,
  ///signedData: null
  signed: false
}

const transactionReducer = (state=INITIAL_STATE, action) => {
  switch(action.type) {
    case TransactionActionTypes.FETCH_TRANSACTION_SUCCESS:
      return {
        ...state,
        data: action.payload
      }
    case TransactionActionTypes.SEND_TO_ESIGNER_FINISH: 
      return {
        ...state, 
        data: {
          ...state.data,
          userCert: action.payload.userCertificate,
          documents: [...action.payload.documents]
        }
      }
    case TransactionActionTypes.SEND_TO_EMBEDDING_API_SUCCESS:
      return {
        ...state,
        signed: true
      }
    default:
      return state
  }
}

export default transactionReducer